//import 'bootstrap';
$( document ).ready( () => {
  const hamb = document.querySelector( "#hamb" );
  const mainNav = document.querySelector( "#main-nav" );
  const overlay = document.querySelector( "#overlay" );
  const closeMenuBtn = document.querySelector( "#close-menu" );
  const searchBtn = document.querySelector( "#search-btn" );
  const closeSearchBtn = document.querySelector( "#close-search-btn" );
  const searchModal = document.querySelector( "#search-modal" );

  hamb.addEventListener(
    "click",
    function ( e ) {
      e.stopPropagation();
      openMenu();
    },
    false
  );

  closeMenuBtn.addEventListener(
    "click",
    function ( e ) {
      e.stopPropagation();
      closeMenu();
    },
    false
  );

  searchBtn.addEventListener(
    "click",
    function ( e ) {
      e.stopPropagation();
      openSearch();
    },
    false
  );

  closeSearchBtn.addEventListener(
    "click",
    function ( e ) {
      e.stopPropagation();
      closeSearch();
    },
    false
  );

  // opens the search
  function openSearch () {
    //console.log("opensearch function");
    searchModal.classList.remove( "hidden" );
  }

  // closes the search
  function closeSearch () {
    searchModal.classList.add( "hidden" );
  }

  // opens main nav
  function openMenu () {
    //console.log("opening nav");
    mainNav.classList.add( "open" );
    overlay.classList.remove( "hidden" );
    console.log( 'menu opening' );
  }


  function openSubMenu () {
    const submenus = document.querySelectorAll( ".dropdown-menu" );

    submenus.forEach( ( dropdownList ) => {
      const trigger = dropdownList.previousElementSibling;
      if ( !trigger ) return;

      if ( trigger.dataset.listenerAttached ) return;
      trigger.dataset.listenerAttached = true;

      trigger.addEventListener( "click", ( e ) => {
        const hasSubmenu = dropdownList.classList.contains( "dropdown-menu" );
        if ( !hasSubmenu ) return;

        e.preventDefault();

        const parentLi = dropdownList.parentElement; // the <li> that contains this submenu

        // If already open, follow the link
        if ( dropdownList.classList.contains( "open" ) ) {
          window.location.href = trigger.href;
          return;
        }

        // --- CLOSE OTHER SUBMENUS AT SAME LEVEL ---
        const siblingDropdowns = Array.from( parentLi.parentElement.children )
          .filter( li => li !== parentLi )
          .map( li => li.querySelector( ":scope > .dropdown-menu" ) )
          .filter( Boolean );

        siblingDropdowns.forEach( siblingDropdown => {
          const siblingTrigger = siblingDropdown.previousElementSibling;
          const siblingParent = siblingDropdown.parentElement;

          siblingDropdown.classList.remove( "open", "active" );
          siblingTrigger?.classList.remove( "active" );
          siblingParent?.classList.remove( "open" );
        } );

        // --- OPEN CLICKED SUBMENU ---
        dropdownList.classList.add( "open", "active" );
        trigger.classList.add( "active" );
        parentLi.classList.add( "open" );
      } );

      // Recursively initialize nested submenus
      openSubMenu.call( dropdownList );
    } );
  }

  window.addEventListener( "load", openSubMenu );




  // closes main nav
  function closeMenu () {
    //console.log("closing nav");
    mainNav.classList.remove( "open" );
    overlay.classList.add( "hidden" );
  }

  // add scrolled class to header on scroll
  function headerScroll () {
    if ( window.pageYOffset > 100 ) {
      document.querySelector( "header" ).classList.add( "scrolled" );
    } else {
      document.querySelector( "header" ).classList.remove( "scrolled" );
    }
  }
  headerScroll();
  window.addEventListener( "scroll", headerScroll );

  // animate on scroll library
  AOS.init();

  var dropdowns = document.querySelectorAll( ".dropdown" );
  var viewportWidth = $( window ).width();
  //console.log(viewportWidth);

  $( "body" ).click( function () {
    //closeSearch();
    closeAllDropDowns();
  } );

  $( window ).scroll( function () {
    if ( viewportWidth <= 1023 ) {
      return;
    } else {
      closeSearch();
      closeAllDropDowns();
    }
  } );

  // $('#searchHolderDesktop button').click(function (e) {
  //     e.stopPropagation()
  //     openSearch();
  // });

  // $('#searchHolderDesktop form').click(function (e) {
  //     e.stopPropagation()
  //     //openSearch();
  // });

  // function openSearch() {
  //     $('#searchHolderDesktop').addClass('active')
  //     $('#searchHolderDesktop form input.search-field').focus()
  //     $('.topnav a, .topnav .pipe').each(function () {
  //         $(this).addClass('hidden')
  //     })
  // }

  // function closeSearch() {
  //     $('#searchHolderDesktop').removeClass('active');
  //     $('#searchHolderDesktop form input.search-field').blur()
  //     $('.topnav a, .topnav .pipe').each(function () {
  //         $(this).removeClass('hidden')
  //     })
  // }

  function closeAllDropDowns () {
    $( "header" ).removeClass( "active" );
    $( ".underlay" ).removeClass( "active" );
    $( dropdowns ).each( function () {
      $( this ).removeClass( "open" );
    } );
  }

  // on resize, reset this wiewport width
  window.addEventListener( "resize", function () {
    closeAllDropDowns();
    closeMenu();
    viewportWidth = $( window ).width();
    //console.log(viewportWidth);
  } );

  $( "header .dropdown a" ).click( function ( e ) {
    if ( viewportWidth > 1023 ) return;
    e.stopPropagation();
    //console.log("click click");
    closeAllDropDowns();
    //$('header').addClass('active'); $('.underlay').addClass('active');
    $( this ).parent().addClass( "open" );
  } );

  $( "header .dropdown a" ).click( function ( e ) {
    e.stopPropagation();
  } );

  // A second-level flyout with enough items (e.g. Testing Services' ~9
  // sub-links) can be taller than a short laptop screen. It opens with its
  // top pinned to its trigger <li> (position:relative is the offsetParent,
  // top:0 in CSS), so on a short viewport it just runs off the bottom with
  // no way to reach the rest — scrolling the page to chase it doesn't work
  // either, since it's position:absolute and moving it out from under a
  // stationary cursor fires mouseleave, closing it.
  //
  // Prefer sliding the flyout up so its bottom lands inside the viewport
  // (no scrolling needed at all, which is the better experience) by
  // overriding that top:0 with a negative offset. Only if it's tall enough
  // that even flush with the top of the viewport it still wouldn't fit do
  // we fall back to capping its height and letting it scroll internally
  // (header.pcss gives it overflow-y:auto + overscroll-behavior:contain so
  // that scroll can't chain to the page once it hits bottom).
  //
  // Only the second level gets any of this: giving the first level its own
  // overflow-y would force overflow-x to compute as auto too, clipping the
  // second level's flyout, which renders outside the first level's box.
  function fitDropdownHeight ( el, triggerLi ) {
    const bottomPadding = 24;
    const topPadding = 12;
    const liTop = triggerLi.getBoundingClientRect().top;
    const naturalHeight = el.scrollHeight;

    el.style.top = "";
    el.style.maxHeight = "";

    const naturalBottom = liTop + naturalHeight;
    if ( naturalBottom + bottomPadding <= window.innerHeight ) return; // fits as-is

    const desiredTop = window.innerHeight - bottomPadding - naturalHeight;
    const clampedTop = Math.max( desiredTop, topPadding );
    el.style.top = ( clampedTop - liTop ) + "px";

    if ( clampedTop > desiredTop ) {
      // Even flush against the top of the viewport it's still too tall —
      // cap it and let the overflow scroll internally.
      el.style.maxHeight = ( window.innerHeight - clampedTop - bottomPadding ) + "px";
    }
  }

  // Desktop hover interactions with delayed close to prevent flicker
  $( "header div.dropdown[itemscope]" ).mouseenter( function () {
    const $self = $( this );
    const pending = $self.data( "closeTimer" );
    if ( pending ) {
      clearTimeout( pending );
      $self.removeData( "closeTimer" );
    }
    if ( $self.hasClass( "open" ) ) return;
    if ( viewportWidth <= 1023 ) return;
    closeAllDropDowns();
    $( "header" ).addClass( "active" );
    $( ".underlay" ).addClass( "active" );
    $self.addClass( "open" );
  } );

  $( "header div.dropdown li.dropdown:not(.open)" ).mouseenter( function () {
    const $self = $( this );
    const pending = $self.data( "closeTimer" );
    if ( pending ) {
      clearTimeout( pending );
      $self.removeData( "closeTimer" );
    }
    if ( viewportWidth <= 1023 ) return;
    $self.addClass( "open" );
    const menu = $self.children( "ul.dropdown-menu" ).get( 0 );
    if ( menu ) fitDropdownHeight( menu, this );
  } );

  function scheduleClose ( $el ) {
    const existing = $el.data( "closeTimer" );
    if ( existing ) clearTimeout( existing );
    const id = setTimeout( () => {
      $el.removeClass( "open" );
      $el.find( "li.dropdown" ).removeClass( "open" );
      $el.removeData( "closeTimer" );
    }, 150 );
    $el.data( "closeTimer", id );
  }
  function clearClose ( $el ) {
    const id = $el.data( "closeTimer" );
    if ( id ) {
      clearTimeout( id );
      $el.removeData( "closeTimer" );
    }
  }

  $( "header div.dropdown[itemscope]" ).mouseleave( function () {
    if ( viewportWidth <= 1023 ) return;
    scheduleClose( $( this ) );
  } );

  $( "header div.dropdown[itemscope] > ul.dropdown-menu" )
    .on( "mouseenter", function () {
      if ( viewportWidth <= 1023 ) return;
      const $parent = $( this ).closest( "div.dropdown[itemscope]" );
      clearClose( $parent );
    } )
    .on( "mouseleave", function () {
      if ( viewportWidth <= 1023 ) return;
      const $parent = $( this ).closest( "div.dropdown[itemscope]" );
      scheduleClose( $parent );
    } );

  $( "header div.dropdown li.dropdown" )
    .mouseleave( function () {
      if ( viewportWidth <= 1023 ) return;
      scheduleClose( $( this ) );
    } )
    .mouseenter( function () {
      if ( viewportWidth <= 1023 ) return;
      clearClose( $( this ) );
    } );

  $( "header div.dropdown li.dropdown > ul.dropdown-menu" )
    .on( "mouseenter", function () {
      if ( viewportWidth <= 1023 ) return;
      const $parent = $( this ).closest( "li.dropdown" );
      clearClose( $parent );
    } )
    .on( "mouseleave", function () {
      if ( viewportWidth <= 1023 ) return;
      const $parent = $( this ).closest( "li.dropdown" );
      scheduleClose( $parent );
    } );
} );